import Router from './routes.js'  
import 'bootstrap/dist/css/bootstrap.min.css'
import 'bootstrap/dist/js/bootstrap.bundle.js'
import './dist/css/global.css'

function App() {
  return (
    <div className="App">
      <Router/>
    </div>
  );
}

export default App;
